import { Button } from "common/Components/Button";
import { FingerRegisterIcon } from "common/Icons"
import { UseIsMobile } from "common/hooks/UseIsMobile";
import { useReturnToApp } from "common/hooks/returnToApp";
// import Cookies from "js-cookie";
import { useFingerPrint } from "pages/Login/hooks/useFingerPrint";
// import { useEffect } from "react";
// import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "redux/store";




export const FingerRegister = () => {
    // const { t } = useTranslation();
    const mobile = UseIsMobile()
    const {
        autorizationSlice: { callBackUrl },
    } = useSelector((state: RootState) => state);

    const { pushReturn } = useReturnToApp();

    const { registerMakeCredentialOption, registerWebAuth, registerMakeCredential } = useFingerPrint()


    //temporary
//     let params = new URLSearchParams(window.location.search)
//     useEffect(() => {
//         const token = params.get("token") || "189Fah/vZEDAhZ0qjND2aYTY9GJ1/KVXGACvhWerqa/e/Wf0n+slyg03g==";
// 
//         if (token) {
//             Cookies.set("client_id", token);
//         }
//     }, [])
//     //

    const goToApp = () => {
        pushReturn(callBackUrl)
    };


    const registerWithFingerprints = () => {
        registerMakeCredentialOption()
            .then(registerWebAuth)
            .then(registerMakeCredential)
            .then((res) => {
                if (res.status === "ok") {
                    toast.success('فعالسازی اثرانگشت / تشخیص چهره با موفقیت انجام شد.');
                    const clear = setTimeout(() => {
                        goToApp()
                        clearTimeout(clear)
                    }, 1000);
                } else {
                    toast.error('فعالسازی با موفقیت انجام نشد..');
                    console.log("unSuccessfully register", res)
                }
            })
    }


    return (

        <div>
            {
                mobile ?
                    <div className="md:hidden">
                        <div className="flex flex-col justify-between h-[90vh]">

                            <div className="p-4">
                                <div className="absolute left-0 -top-4">
                                    <FingerRegisterIcon />
                                </div>
                                <div className="mt-72 text-center">
                                    <h1 className="text-5xl font-medium mb-2">
                                        {/* {t(`FormSide.Finger-register`)} */}
                                        فعالسازی اثرانگشت / تشخیص چهره
                                    </h1>
                                    <p className="pt-9 text-2xl text-L-gray-250">
                                        {/* {t(`FormSide.Finger-register-allow`)} */}
                                        آیا اجازه فعالسازی اثرانگشت / تشخیص چهره را میدهید؟
                                    </p>
                                </div>
                            </div>

                            <div className="p-6">
                                <Button
                                    type='submit'
                                    className="w-full bg-L-secondary-50 dark:bg-D-secobg-L-secondary-50 rounded text-L-basic dark:text-D-basic p-2"
                                    onClick={registerWithFingerprints}
                                >
                                    بله، فعال میکنم
                                </Button>
                                <Button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        goToApp()
                                    }}
                                    className="w-full mt-2"
                                >
                                    انصراف
                                </Button>
                            </div>

                        </div>
                    </div>
                    :
                    <div className="hidden md:block">
                        <h1>این صفحه فقط در حالت موبایل در دسترس می باشد</h1>
                    </div>
            }
        </div>



    )
}
